var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"zelan-data-placeholder"},[_c('div',{staticClass:"zelan-data-placeholder__empty-icon"}),_c('p',{staticClass:"zelan-data-placeholder__text"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }